import Vue from 'vue';
import Router from 'vue-router';
import routes from './routes';
import { isLoggedIn, isUserHasRole } from '../helpers/user';

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const checkLogin = to.matched.find(x => x.meta && x.meta.auth);
  if (!checkLogin) {
    next();
  } else if (isLoggedIn()) {
    if (to.meta && to.meta && to.meta.enabledRoles) {
      const isRoleSuitable = to.meta.enabledRoles.some(roleId => isUserHasRole(roleId));

      if (isRoleSuitable) {
        next();
      } else {
        next({ path: '/' });
      }
    } else {
      next();
    }
  } else {
    next({ name: 'login' });
  }
});

export default router;
